import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import InfoSidePanel from "../InfoSidePanel.js";

function HomeInfoPanel() {
    const [popularCategories, setPopularCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const controller = new AbortController();

        setLoading(true);
        fetch("/api/categories", { signal: controller.signal })
            .then((res) => res.json())
            .then((data) => {
                const categories = Array.isArray(data) ? data : [];
                const sorted = [...categories]
                    .sort((a, b) => (b.post_count ?? 0) - (a.post_count ?? 0))
                    .slice(0, 5);
                setPopularCategories(sorted);
            })
            .catch((err) => {
                if (err.name !== "AbortError") {
                    console.error("인기 커뮤니티 불러오기 실패:", err);
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            });

        return () => controller.abort();
    }, []);

    return (
        <InfoSidePanel ariaLabel="추천 정보">
            <div className="community-info-section">
                <span className="community-info-label">인기 커뮤니티</span>
                {loading ? (
                    <p className="community-info-empty">불러오는 중...</p>
                ) : popularCategories.length > 0 ? (
                    <ul className="community-popular-post-list">
                        {popularCategories.map((category) => (
                            <li key={category.id}>
                                <Link to={`/community?category=${category.id}`}>
                                    <strong>{category.name}</strong>
                                    <span>게시글 {category.post_count ?? 0}개</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="community-info-empty">인기 커뮤니티 정보가 없습니다.</p>
                )}
            </div>

            <div className="community-info-section">
                <span className="community-info-label">광고</span>
                <div className="home-info-ad-placeholder">
                    <span className="material-symbols-rounded" aria-hidden="true">campaign</span>
                    <p>광고 영역</p>
                </div>
            </div>
        </InfoSidePanel>
    );
}

export default HomeInfoPanel;
